import stepper_hostHtml from './stepper-host.html?raw';

export const template = stepper_hostHtml;

export interface IStepperStep {
    labelKey: string;
    descriptionKey: string;
}

export interface IStepperHostParams {
    visible: KnockoutObservable<boolean>;
    /** 0-based index among visible steps */
    currentIndex: KnockoutObservable<number>;
    steps: ReadonlyArray<IStepperStep>;
}

export class viewModel {
    constructor(public params: IStepperHostParams) {}
}
